export type PjCompletenessField = {
  key: string
  label: string
  ok: boolean
}

export type PjCompletenessInput = {
  nomeCompleto?: string | null
  email?: string | null
  telefone?: string | null
  cpf?: string | null
  cnpj?: string | null
  razaoSocial?: string | null
  cep?: string | null
  logradouro?: string | null
  numero?: string | null
  cidade?: string | null
  uf?: string | null
  bancoNome?: string | null
  bancoAgencia?: string | null
  bancoConta?: string | null
  bancoTipoConta?: string | null
  pixChave?: string | null
}

const PLACEHOLDER_PHONE = '0000000000'
const PENDING_NAME = 'Aguardando preenchimento'

function hasText(value?: string | null): boolean {
  return Boolean(value?.trim())
}

export function isPlaceholderPjPhone(telefone?: string | null): boolean {
  if (!telefone) return true
  const digits = telefone.replace(/\D/g, '')
  return digits === '' || digits === PLACEHOLDER_PHONE
}

export function evaluatePjAgradaCompleteness(pj: PjCompletenessInput) {
  const fields: PjCompletenessField[] = [
    {
      key: 'nomeCompleto',
      label: 'Nome completo',
      ok: hasText(pj.nomeCompleto) && pj.nomeCompleto?.trim() !== PENDING_NAME,
    },
    { key: 'email', label: 'E-mail', ok: hasText(pj.email) },
    { key: 'telefone', label: 'Telefone / WhatsApp', ok: !isPlaceholderPjPhone(pj.telefone) },
    { key: 'documento', label: 'CPF ou CNPJ', ok: hasText(pj.cpf) || hasText(pj.cnpj) },
    { key: 'cep', label: 'CEP', ok: hasText(pj.cep) },
    { key: 'logradouro', label: 'Logradouro', ok: hasText(pj.logradouro) },
    { key: 'numero', label: 'Número', ok: hasText(pj.numero) },
    { key: 'cidade', label: 'Cidade', ok: hasText(pj.cidade) },
    { key: 'uf', label: 'UF', ok: hasText(pj.uf) },
    {
      key: 'banco',
      label: 'Dados bancários (banco, agência e conta)',
      ok: hasText(pj.bancoNome) && hasText(pj.bancoAgencia) && hasText(pj.bancoConta),
    },
    { key: 'bancoTipoConta', label: 'Tipo de conta', ok: hasText(pj.bancoTipoConta) },
    { key: 'pixChave', label: 'Chave PIX', ok: hasText(pj.pixChave) },
  ]

  if (hasText(pj.cnpj)) {
    fields.push({
      key: 'razaoSocial',
      label: 'Razão social (CNPJ)',
      ok: hasText(pj.razaoSocial),
    })
  }

  const missing = fields.filter((field) => !field.ok)
  const complete = missing.length === 0
  const percent =
    fields.length === 0 ? 0 : Math.round(((fields.length - missing.length) / fields.length) * 100)

  return { fields, missing, complete, percent }
}
